<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5" shaped>
            <v-row dense>
              <v-col cols="12">
                <strong>AAM - PUSH ACTIVITY APPROVAL</strong>
              </v-col>
            </v-row>
            <hr />
            <v-row>
              <v-col cols="12">
                <v-card class="pa-2">
                  <v-row dense>
                    <v-col cols="2" align-self="center">PERIOD</v-col>
                    <v-col cols="5">
                      <v-menu
                        v-model="openStartPeriod"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                          color="red darken-1"
                            v-model="periodStart"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            solo
                            hide-details
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="periodStart" type="month" @input="openStartPeriod = false" color="red darken-1"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row dense>
                      <v-col cols="2">
                    </v-col>
                    <v-col cols="5">
                      <v-btn @click="filterDataTable" color="warning" block>FIND</v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-card class="pa-3" outlined>
                  <v-data-table
                    v-model="selected"
                    :headers="dtHeaders"
                    :items="dtItemsHeader"
                    :search="searchRole"
                    :loading="dtLoading"
                    loading-text="Fetching Data..."
                    dense
                    show-select
                    single-expand
                    class="elevation-1"
                    item-key="ACTIVITY_HEADER_ID"                    
                  >
                  <template v-slot:item.DetailTitle="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="DetailTitle(item)"
                    >
                      mdi-list-box-outline
                    </v-icon>
                  </template>
                   <template v-slot:item.DetailBranch="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="DetailBranch(item)"
                    >
                     mdi-list-box-outline
                    </v-icon>
                  </template>
                  <template v-slot:item.DetailChannel="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="DetailChannel(item)"
                    >
                      mdi-list-box-outline
                    </v-icon>
                  </template>
                  <template v-slot:item.DetailProduct="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="DetailProduct(item)"
                    >
                      mdi-list-box-outline
                    </v-icon>
                  </template>
                   <template v-slot:item.DetailCust="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="DetailCust(item)"
                    >
                      mdi-list-box-outline
                    </v-icon>
                  </template>
                   <template v-slot:item.DetailQues="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="DetailQues(item)"
                    >
                      mdi-list-box-outline
                    </v-icon>
                  </template>
                  </v-data-table>
                  <div class="d-flex justify-center">                    
                    <v-btn @click="reject" small class="mx-1" color="error"
                      >REJECT</v-btn
                    >
                    <v-btn @click="approve" small class="mx-1" color="warning"
                      >APPROVE</v-btn
                    >
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!--dialog Title-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogTitle"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-data-table
              v-model="titlepa"
              :headers="dtHeaderTitle"
              :items="dtItemsTitle"
              item-key="TITTLE_ID"
              :loading="dtLoading"
              class="elevation-1"
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>

     <!--dialog Branch-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogBranch"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-data-table
              v-model="titlbranch"
              :headers="dtHeaderBranch"
              :items="dtItemsBranch"
              item-key="BRANCH_CODE"
              :loading="dtLoading"
              class="elevation-1"
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>

      <!--dialog Channel-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogChannel"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-data-table
              v-model="titlchannel"
              :headers="dtHeaderChannel"
              :items="dtItemsChannel"
              item-key="CHANNEL_GROUP"
              :loading="dtLoading"
              class="elevation-1"
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>

       <!--dialog product-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogProduct"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-data-table
              v-model="titlproduct"
              :headers="dtHeaderProduct"
              :items="dtItemsProduct"
              item-key="PRODUCT_GROUP"
              :loading="dtLoading"
              class="elevation-1"
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>

    <!--dialog customer-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogCust"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-data-table
              v-model="titlcust"
              :headers="dtHeaderCust"
              :items="dtItemsCust"
              item-key="CUSTOMER_NAME"
              :loading="dtLoading"
              class="elevation-1"
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>

    <!--dialog Question-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogQues"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-data-table
            dense
          disable-sort
              v-model="titlQues"
              :headers="dtHeaderQues"
              :items="dtItemsQues"
               :expanded.sync="expanded"       
                group-by="QUESTION"
                class="elevation-1"         
              :loading="dtLoading"
            >
             <template v-slot:group.header="{ group, headers, toggle, isOpen }">
                <td :colspan="headers.length">
                    <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
                        <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                        <v-icon v-else>mdi-chevron-down</v-icon>
                    </v-btn>
                    {{ group }}
                </td>
            </template>
            </v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>

    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";
import XLSX from "xlsx";

const dtHeaders = [
  {
    text: "Campaign Name",
    value: "ACTIVITY_HEADER_NAME",
  },
  {
    text: "Campaign Desc",
    value: "ACTIVITY_HEADER_DESC",
  },
  {
    text: "Period Start",
    value: "START_ACTIVITY_PERIODE",
  },
  {
    text: "Period End",
    value: "END_ACTIVITY_PERIODE",
  },
  {
    text: "Role",
    value: "EMPLOYEE_TYPE_CODE",
  },
  {
    text: "Title",
    value: "DetailTitle",
  },
  {
    text: "Branch",
    value: "DetailBranch",
  },
  {
    text: "Sales Channel",
    value: "DetailChannel",
  },
  {
    text: "Product",
    value: "DetailProduct",
  },
  {
    text: "Outlet",
    value: "DetailCust",
  },
  {
    text: "Activity",
    value: 'DetailQues'
  }
];

const dtHeaderTitle = [
  {
    text: "TITTLE DESC",
    value: "TITTLE_DESC",
  }
];

const dtHeaderBranch = [
  {
    text: "BRANCH CODE",
    value: "BRANCH_CODE",
  }
];

const dtHeaderChannel = [
  {
    text: "CHANNEL GROUP",
    value: "CHANNEL_GROUP",
  }
];

const dtHeaderProduct = [
  {
    text: "PRODUCT GROUP",
    value: "PRODUCT_GROUP",
  }
];

const dtHeaderCust = [
  {
    text: "CUSTOMER NAME",
    value: "CUSTOMER_NAME",
  }
];

const dtHeaderQues = [
  {
    text: "QUESTION",
    value: "QUESTION"
  },
  {
     text: "TYPE",
    value: "TYPE",
  },
  {
     text: "ANSWER DESC",
    value: "ANSWER_DESC",
  }
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      branchList: [],
      branch: null,
      searchRole: "",
      dtLoading: false,
      dtHeaders,
      dtHeaderTitle,
      dtHeaderBranch,
      dtHeaderChannel,
      dtHeaderProduct,
      dtHeaderCust,
      dtHeaderQues,
      dtItemsHeader: [],
      dtItemsTitle: [],
      dtItemsBranch: [],
      dtItemsChannel: [],
      dtItemsProduct: [],
      dtItemsCust: [],
      dtItemsQues: [],
      position: "",
      selected: [],
      invoiceNo: "",
      openStartPeriod: false,
      openEndPeriod: false,
      orgID :JSON.parse(localStorage.getItem('userData')).ORG_ID,
     period: moment().format("YYYY-MM"),
      userIdUpdate: JSON.parse(localStorage.getItem('userData')).USER_ID,
      dialogTitle: false,
      dialogBranch: false,
      dialogChannel: false,
      dialogProduct: false,
      dialogCust: false,
      dialogQues: false
    };
  },
  mounted() {
    console.log('test ', JSON.parse(localStorage.getItem('userData')));
  },
  methods: {
    DetailTitle(item){
      this.getTitle(item.ACTIVITY_HEADER_ID);      
    },
    DetailBranch(item){
      this.getBranch(item.ACTIVITY_HEADER_ID);      
    },
    DetailChannel(item){
      this.getChannel(item.ACTIVITY_HEADER_ID);      
    },
    DetailProduct(item){
      this.getProduct(item.ACTIVITY_HEADER_ID);      
    },
     DetailCust(item){
      this.getCust(item.ACTIVITY_HEADER_ID);      
    },
    DetailQues(item){
      this.getQues(item.ACTIVITY_HEADER_ID);      
    },
    getTitle(headerID){
      this.dtLoading = true;
      const data = {
        headerID
      };
      console.log('data ', data);
      this.$http
        .post("/pushact/loadTitle", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {          
          let  data  = res.data.data.resultTitle;
          
          this.dtLoading = false;
          this.dtItemsTitle = data;
          console.log('this.dtItemsTitle  ', this.dtItemsTitle );
          this.dialogTitle=true;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
     getBranch(headerID){
      this.dtLoading = true;
      const data = {
        headerID
      };
      this.$http
        .post("/pushact/loadPABranch", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {          
          let  data  = res.data.data.resultPABranch;
          
          this.dtLoading = false;
          this.dtItemsBranch = data;
          this.dialogBranch=true;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    getChannel(headerID){
      this.dtLoading = true;
      const data = {
        headerID
      };
      this.$http
        .post("/pushact/loadPAChannel", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {          
          let  data  = res.data.data.resultPAChannel;
          
          this.dtLoading = false;
          this.dtItemsChannel = data;
          this.dialogChannel=true;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    getProduct(headerID){
      this.dtLoading = true;
      const data = {
        headerID
      };
      this.$http
        .post("/pushact/loadPAProduct", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {          
          let  data  = res.data.data.resultPAProduct;
          
          this.dtLoading = false;
          this.dtItemsProduct = data;
          this.dialogProduct=true;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    getCust(headerID){
      this.dtLoading = true;
      const data = {
        headerID
      };
      this.$http
        .post("/pushact/loadPACust", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {          
          let  data  = res.data.data.resultPACust;
          
          this.dtLoading = false;
          this.dtItemsCust = data;
          this.dialogCust=true;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    }, 
    getQues(headerID){
      this.dtLoading = true;
      const data = {
        headerID
      };
      this.$http
        .post("/pushact/loadPAQues", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {          
          let  data  = res.data.data.resultPAQuest;
          
          this.dtLoading = false;
          this.dtItemsQues = data;
          this.dialogQues=true;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    filterDataTable() {
      this.dtLoading = true;

      const splitPeriod = this.periodStart.split("-");
      const month = splitPeriod[1];
      const year = splitPeriod[0];
      const data = {
        month,
        year
      };
      console.log('data ', data);
      this.$http
        .post("/pushact/loadApprovalHeader", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          let  data  = res.data.data.resultAppHeader;
          data.forEach((obj, index) => {
            data[index].START_ACTIVITY_PERIODE = moment(data[index].START_ACTIVITY_PERIODE).format(
              "YYYY-MM-DD"
            );
             data[index].END_ACTIVITY_PERIODE = moment(data[index].END_ACTIVITY_PERIODE).format(
              "YYYY-MM-DD"
            );
          });
          this.dtLoading = false;
          this.dtItemsHeader = data;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
    handleClick(value)
    {
      console.log('valcheck ',value)
    },
    approve() { 
       if (confirm(" Apakah Yakin akan lakukan Approve?")) {
          this.isLoading = true;
          let data = {
              USERID_UPDATE : this.userIdUpdate,
              arrSelected : this.selected
            };
          this.$http
            .post('/pushact/approve', data, {
              headers: {
                "api-key": this.$apiKey
              }
            })
            .then((res) => {
              this.isLoading = false;
              const data = res.data;
              if (data.success) {
                this.showSnackbar('Success..');
                this.selected = [];
                this.filterDataTable();
              } else {
                this.showSnackbar('Something is wrong..');
              }
            })
            .catch((err) => {
              this.isLoading = false;
              this.showSnackbar(err.toString());
            });
       }
			
		},
    reject() {
      if (confirm(" Apakah Yakin akan lakukan Reject?")) {
          this.isLoading = true;
          let data = {
              USERID_UPDATE : this.userIdUpdate,
              arrSelected : this.selected
            };
          this.$http
            .post('/pushact/reject', data, {
              headers: {
                "api-key": this.$apiKey
              }
            })
            .then((res) => {
              this.isLoading = false;
              const data = res.data;
              if (data.success) {
                this.showSnackbar('Success..');
                this.selected = [];
                this.filterDataTable();
              } else {
                this.showSnackbar('Something is wrong..');
              }
            })
            .catch((err) => {
              this.isLoading = false;
              this.showSnackbar(err.toString());
            });
      }			
		},
  },
};
</script>
